// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"214":"5a385476","231":"23130eb7","523":"b9767cbc","785":"57922fef"}[chunkId] + ".chunk.css";
};